import React, { useState } from 'react';
import { MessageCircle, X, Send, Phone, Mail } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const whatsappNumber = '+919074140432'; // Your WhatsApp business number
  const defaultMessage = 'Hello! I am interested in your IT services. Please provide more information.';

  const handleSendWhatsApp = () => {
    const text = message || defaultMessage;
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, '_blank');
    setMessage('');
    setIsOpen(false);
  };

  const handleQuickMessage = (quickMsg: string) => {
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(quickMsg)}`;
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
  };

  const handleCall = () => {
    window.open('tel:+919074140432', '_self');
  };

  const handleEmail = () => {
    window.open('mailto:info@x2infotech.in?subject=Inquiry from Website&body=Hello X2InfoTech Team,%0D%0A%0D%0AI am interested in your services. Please contact me.%0D%0A%0D%0AThank you.', '_self');
  };

  const quickMessages = [
    'I need help with custom software development',
    'I want to know about your cloud services',
    'I am interested in mobile app development',
    'I need IT consulting services',
    'I want to discuss a project'
  ];

  return (
    <>
      {/* WhatsApp Chat Widget */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-80 bg-white rounded-lg shadow-2xl border border-gray-200 z-50 animate-scale-in">
          <div className="bg-green-600 text-white p-4 rounded-t-lg">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-3">
                  <MessageCircle className="h-6 w-6 text-green-600" />
                </div>
                <div>
                  <h3 className="font-semibold">X2InfoTech Support</h3>
                  <p className="text-xs opacity-90">Typically replies instantly</p>
                </div>
              </div>
              <button 
                onClick={() => setIsOpen(false)}
                className="text-white hover:bg-green-700 p-1 rounded"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>
          
          <div className="p-4 max-h-80 overflow-y-auto">
            <div className="bg-gray-100 rounded-lg p-3 mb-4">
              <p className="text-sm text-gray-700">
                👋 Hi there! How can we help you today?
              </p>
            </div>
            
            <div className="space-y-2 mb-4">
              <p className="text-xs text-gray-500 font-medium">Quick Messages:</p>
              {quickMessages.map((msg, index) => (
                <button
                  key={index}
                  onClick={() => handleQuickMessage(msg)}
                  className="w-full text-left p-2 text-sm bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-200 border border-gray-200"
                >
                  {msg}
                </button>
              ))}
            </div>
            
            <div className="space-y-3">
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message here..."
                className="w-full p-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                rows={3}
              />
              
              <button
                onClick={handleSendWhatsApp}
                className="w-full bg-green-600 text-white py-2 px-4 rounded-lg font-medium hover:bg-green-700 transition-colors duration-200 flex items-center justify-center"
              >
                <Send className="h-4 w-4 mr-2" />
                Send WhatsApp Message
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Contact Options */}
      <div className="fixed bottom-6 right-6 flex flex-col space-y-3 z-40">
        {/* WhatsApp Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-green-600 text-white p-4 rounded-full shadow-lg hover:bg-green-700 transition-all duration-300 transform hover:scale-110 group animate-bounce"
          title="Chat with us on WhatsApp"
        >
          <MessageCircle className="h-6 w-6 group-hover:animate-pulse" />
        </button>

        {/* Phone Button */}
        <button
          onClick={handleCall}
          className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-110 group"
          title="Call us directly"
        >
          <Phone className="h-5 w-5 group-hover:animate-pulse" />
        </button>

        {/* Email Button */}
        <button
          onClick={handleEmail}
          className="bg-red-600 text-white p-3 rounded-full shadow-lg hover:bg-red-700 transition-all duration-300 transform hover:scale-110 group"
          title="Send us an email"
        >
          <Mail className="h-5 w-5 group-hover:animate-pulse" />
        </button>
      </div>
    </>
  );
};

export default WhatsAppWidget;